import { defineComponent as T, useId as S, useTemplateRef as k, ref as h, inject as B, computed as E, createElementBlock as l, openBlock as p, mergeProps as N, unref as a, createElementVNode as s, withModifiers as u, normalizeClass as d, renderSlot as m, createTextVNode as C, toDisplayString as f, createVNode as R, createCommentVNode as P } from "vue";
import n from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Nav/nav.js";
import V from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/utilities/Accessibility/accessibility.js";
import { useOUIAProps as O } from "../../helpers/ouia.js";
import { AngleRightIcon as $ } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { SidebarOpenKey as w } from "../Page/PageSidebar.vue2.js";
const A = ["id", "aria-expanded", "tabindex"], L = ["aria-labelledby", "hidden"], M = ["id"], F = /* @__PURE__ */ T({
  name: "PfNavExpandable",
  __name: "NavExpandable",
  props: {
    title: {},
    srText: {},
    groupId: {},
    id: { default: () => S() },
    active: { type: Boolean },
    managed: { type: Boolean },
    expanded: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["update:expanded"],
  setup(c, { emit: v }) {
    const t = c, g = O({ id: t.ouiaId, safe: t.ouiaSafe }), b = v, x = k("expandableRef"), r = h(t.expanded), y = B(w, !1), i = E({
      get() {
        return t.managed ? r.value : t.expanded;
      },
      set(e) {
        t.managed ? r.value = e : b("update:expanded", e, t.groupId);
      }
    });
    function I(e) {
      var o;
      e.target instanceof Element && (o = x.value) != null && o.contains(e.target) && (i.value = !i.value);
    }
    return (e, o) => (p(), l("li", N(a(g), {
      class: [a(n).navItem, {
        [a(n).modifiers.expanded]: i.value,
        [a(n).modifiers.current]: e.active
      }],
      onClick: I
    }), [
      s("button", {
        id: e.srText ? void 0 : e.id,
        ref: "expandableRef",
        type: "button",
        class: d(a(n).navLink),
        "aria-expanded": i.value,
        tabindex: a(y) ? void 0 : -1,
        onClick: o[0] || (o[0] = u(() => {
        }, ["prevent"])),
        onMousedown: o[1] || (o[1] = u(() => {
        }, ["prevent"]))
      }, [
        s("span", {
          class: d(`${a(n).nav}__link-text`)
        }, [
          m(e.$slots, "title", {}, () => [
            C(f(e.title), 1)
          ])
        ], 2),
        s("span", {
          class: d(a(n).navToggle)
        }, [
          s("span", {
            class: d(a(n).navToggleIcon)
          }, [
            R(a($))
          ], 2)
        ], 2)
      ], 42, A),
      s("section", {
        class: d(a(n).navSubnav),
        "aria-labelledby": e.id,
        hidden: !i.value || void 0
      }, [
        e.srText ? (p(), l("h2", {
          key: 0,
          id: e.id,
          class: d(a(V).screenReader)
        }, f(e.srText), 11, M)) : P("", !0),
        s("ul", {
          class: d(a(n).navList),
          role: "list"
        }, [
          m(e.$slots, "default")
        ], 2)
      ], 10, L)
    ], 16));
  }
});
export {
  F as default
};
